import { Button, Flex, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import { t } from "i18next";
import { IconBin } from "../../../components/Icons/IconBin";
import {
  IKategorijaVrstaZahtevaDtoProps,
  IPodaciOTrazenimMarkicamaPrint,
  RequestedStampsInfoTableColumnName,
} from "./exciseStamps.types";

export const calculateNedostajuceVrednosti = (
  nedostajuceVrednosti: string[] | null | undefined
) => {
  if (
    !nedostajuceVrednosti ||
    !nedostajuceVrednosti?.length ||
    nedostajuceVrednosti?.every((el: null | string) => !el)
  ) {
    return 0;
  }

  return nedostajuceVrednosti?.length;
};

export const getRequestedStampsInfoTableColumns = ({
  hiddenColumns,
  editable,
  rowAction,
}: {
  hiddenColumns?: Array<RequestedStampsInfoTableColumnName>;
  editable?: boolean;
  rowAction?: (index: number) => void;
}) => {
  const allColumns = [
    {
      title: t("AKCIZNE_MARKICE.VRSTE_AKCIZNE_MARKICE"),
      dataIndex: "markicaKategorijeVrsteIme",
      key: "markicaKategorijeVrsteIme",
      align: "left",
      width: "100%",
    },
    {
      title: t("AKCIZNE_MARKICE.OZNAKA_PAKOVANJA"),
      dataIndex: "pakovanjeOznaka",
      key: "pakovanjeOznaka",
    },
    {
      title: t("AKCIZNE_MARKICE.TRAZENE_KOLICINE"),
      dataIndex: "kolicina",
      key: "kolicina",
    },
    {
      title: t("AKCIZNE_MARKICE.VELICINA_PAKOVANJA"),
      dataIndex: "tipPakovanja",
      key: "tipPakovanja",
    },
    {
      title: t("AKCIZNE_MARKICE.OPSEG_SERIJSKIH_BROJEVA"),
      key: "opseg",
      render: (row: IKategorijaVrstaZahtevaDtoProps) => {
        return (
          <Flex gap={10} vertical>
            {row.isporuceniOpsezi?.map((opseg) => (
              <Flex>
                <Tag bordered={false}>{t("AKCIZNE_MARKICE.OD")}</Tag>
                <Tag>{opseg.isporuceniOpsegOd || "/"}</Tag>
                <Tag bordered={false}>{t("AKCIZNE_MARKICE.DO")}</Tag>
                <Tag>{opseg.isporuceniOpsegDo || "/"}</Tag>
              </Flex>
            ))}
          </Flex>
        );
      },
    },
    {
      title: t("AKCIZNE_MARKICE.NEDOSTAJUCE_VREDNOSTI"),
      key: "nedostajuceVrednosti",
      render: (row: IKategorijaVrstaZahtevaDtoProps) =>
        calculateNedostajuceVrednosti(row?.nedostajuceVrednosti),
    },
    ...(editable
      ? [
          {
            dataIndex: "actions",
            key: "action",
            align: "right",
            width: "10%",
            render: (_text: string, _record: string, index: number) => (
              <Button
                style={{ border: "none" }}
                icon={<IconBin />}
                onClick={() => rowAction?.(index)}
              />
            ),
          },
        ]
      : []),
  ] as ColumnsType<Partial<IKategorijaVrstaZahtevaDtoProps>>;

  return allColumns.filter(
    (column) =>
      !hiddenColumns?.includes(column.key as RequestedStampsInfoTableColumnName)
  );
};

export const mapPodaciOTrazenimMarkicamaPrint = (
  podaciOTrazenimMarkicama: IPodaciOTrazenimMarkicamaPrint
): Partial<IKategorijaVrstaZahtevaDtoProps> => {
  return {
    markicaKategorijeVrsteIme:
      podaciOTrazenimMarkicama.markicaKategorijeVrsteIme,
    pakovanjeOznaka:
      podaciOTrazenimMarkicama.pakovanjeOznaka ??
      podaciOTrazenimMarkicama.pakovanjeOpis,
    kolicina: podaciOTrazenimMarkicama.kolicina,
    isporuceniOpsezi: podaciOTrazenimMarkicama.isporuceniOpsezi,
    tipPakovanja: podaciOTrazenimMarkicama.tipPakovanja,
    tipPakovanjaShow: podaciOTrazenimMarkicama.tipPakovanjaShow,
  } as Partial<IKategorijaVrstaZahtevaDtoProps>;
};
